<script setup lang="ts">
import type { Table } from '@tanstack/vue-table'
import { Member } from '@/types/Member'
import { Button } from '@/components/ui/button'

import { Input } from '@/components/ui/input'
import { computed } from 'vue'
import { active, disabled } from '@/data/userdata'
import DataTableFacetedFilter from '@/components/DataTableFacetedFilter.vue'
import UserDataTableViewOptions from '@/components/UserDataTableViewOptions.vue'

interface UserTableFilterProps {
	table: Table<Member>
}

const props = defineProps<UserTableFilterProps>()

const isFiltered = computed(() => props.table.getState().columnFilters.length > 0)
</script>

<template>
	<div class="flex items-center justify-between">
		<div class="flex flex-1 items-center space-x-2">
			<Input placeholder="Filter Users..." :model-value="(table.getColumn('email')?.getFilterValue() as string) ?? ''" class="h-8 w-[150px] lg:w-[250px]" @input="table.getColumn('email')?.setFilterValue($event.target.value)" />
			<DataTableFacetedFilter v-if="table.getColumn('active')" :column="table.getColumn('active')" title="Status" :options="active" />
			<DataTableFacetedFilter v-if="table.getColumn('disabled')" :column="table.getColumn('disabled')" title="Priority" :options="disabled" />
			<Button v-if="isFiltered" variant="ghost" class="h-8 px-2 lg:px-3" @click="table.resetColumnFilters()" > Reset
			</Button>
		</div>
		<UserDataTableViewOptions :table="table" />
	</div>
</template>
